const YOUTUBE_PATTERN =
    /(?:youtube\.com\/(?:watch\?[^#]*?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/i;

const RUTUBE_VIDEO_PATTERN = /rutube\.ru\/video\/([a-zA-Z0-9_-]+)/i;
const RUTUBE_EMBED_PATTERN = /rutube\.ru\/(?:play|video)\/embed\/([a-zA-Z0-9_-]+)/i;
const RUTUBE_PL_PATTERN = /[?&]pl_video=([a-zA-Z0-9_-]+)/i;

export const parseVideoUrl = (value) => {
    if (typeof value !== 'string') return null;

    const url = value.trim();
    if (!url) return null;

    const youtubeMatch = url.match(YOUTUBE_PATTERN);
    if (youtubeMatch) {
        return { type: 'youtube', id: youtubeMatch[1] };
    }

    const rutubeMatch =
        url.match(RUTUBE_VIDEO_PATTERN) ||
        url.match(RUTUBE_EMBED_PATTERN) ||
        url.match(RUTUBE_PL_PATTERN);
    if (rutubeMatch) {
        return { type: 'rutube', id: rutubeMatch[1] };
    }

    return null;
};

export const isYouTubeId = (value) =>
    typeof value === 'string' && /^[a-zA-Z0-9_-]{11}$/.test(value);

export const getVideoEmbedUrl = (value) => {
    if (!value) return null;

    if (typeof value === 'string') {
        const parsed = parseVideoUrl(value);
        return parsed ? getVideoEmbedUrl(parsed) : null;
    }

    if (value.type === 'youtube' && value.id) {
        return `https://www.youtube.com/embed/${value.id}`;
    }

    if (value.type === 'rutube' && value.id) {
        return `https://rutube.ru/pl/?pl_id&pl_type&pl_video=${value.id}`;
    }

    return null;
};
